export const REPORT_TYPES = {
  HIGHLIGHT: 'Highlight',
  CYBER_RISK: 'Cyber Risk',
  CLOUD_COMPLIANCE: 'Cloud Compliance',
};

export const REPORT_SOURCES = {
  DISCOVERY: 'Discovery',
  VULNERABILITY_ASSESSMENT: 'Vulnerability assessment',
  DISCOVERY_EMPLOYEES: 'Discovery, Employees',
  CLOUD_COMPLIANCE: 'Cloud Compliance',
};
